<template>
    <div>
<!--        <el-button-->
<!--                size="mini"-->
<!--                type="primary"-->
<!--                plain-->
<!--                disabled-->
<!--                @click="createSubscriptionOpenModal"-->
<!--                style="margin-bottom:15px">{{$t('subscriptions_createSubscription')}}</el-button>-->
        <div class="cancel-anytime" style="margin-bottom:15px;" @click="tester">
<!--{{$t('subscriptions_cancelAtAnyTime')}}-->
          Please note, You can cancel your subscription at anytime.
        </div>
        <el-table
            size="mini"
            style="width: 100%"
            v-loading="loader"
            :data="listWithSum"
            element-loading-text="Loading"
            ref="tabele"
            border
            fit>
            <el-table-column label="Type">
                <template slot-scope="scope">
                  <el-tooltip :content="scope.row.description" placement="top">
                    <span>{{ $t(scope.row.type) }}</span>
                  </el-tooltip>
                </template>
            </el-table-column>
<!--            <el-table-column label="Description">-->
<!--                <template slot-scope="scope">-->
<!--                    {{ scope.row.description }}-->
<!--                </template>-->
<!--            </el-table-column>-->
            <el-table-column width="100" label="Start Date">
                <template slot-scope="scope">
                    {{ scope.row.startDate }}
                </template>
            </el-table-column>
            <el-table-column width="140" align="center" label="User Qty">
                <template slot-scope="scope">
                  <el-input-number
                      class="input-number"
                      size="mini"
                      v-if="typeof scope.row.usersQty === 'number'"
                      v-model="list[scope.$index].usersQty"
                      :min="scope.row.min">
                  </el-input-number>
                  <span v-else>{{ scope.row.usersQty }}</span>
                </template>
            </el-table-column>
            <el-table-column width="80" label="Price">
                <template slot-scope="scope">
                    {{ typeof scope.row.price === 'number' ? `$ ${formatPrice(scope.row.price)}` : scope.row.price }}
                </template>
            </el-table-column>
            <el-table-column width="70" label="Cycle">
                <template slot-scope="scope">
                    {{ scope.row.cycle }}
                </template>
            </el-table-column>
          <el-table-column property="total" width="110" label="Total">
                <template slot-scope="scope">
                    {{ `$ ${formatPrice(scope.row.total)}` }}
                </template>
            </el-table-column>
<!--            <el-table-column :label="$t('users_tab_subscriptions_plans_active')" align="center" width="55">-->
<!--                <template slot-scope="scope">-->
<!--                    <el-button v-if="scope.row.activePlan"-->
<!--                               size="mini"-->
<!--                               type="primary"-->
<!--                               circle-->
<!--                               icon="el-icon-check"></el-button>-->
<!--                </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column :label="$t('users_tab_subscriptions_plans_expiredDate')" align="center" width="100">-->
<!--                <template slot-scope="scope">-->
<!--                    <span v-if="scope.row.activePlan">{{scope.row.expiredDate}}</span>-->
<!--                </template>-->
<!--            </el-table-column>-->
            <el-table-column align="center" :label="$t('users_tab_subscriptions_plans_actions')" width="170">
              <template slot-scope="scope">
                <el-button
                    v-if="scope.row.action"
                    :loading="loading"
                    size="mini"
                    type="primary"
                    plain
                    @click="payConfirm"
                    style="margin-bottom:15px">{{subscription.status === 'trial' ||  subscription.status === 'cancel'  ? 'Pay' : 'Upgrade Plan' }}</el-button>
              </template>
<!--                <template slot-scope="scope">-->
<!--                    <el-button v-if="scope.row.stripeProductId !== null && !scope.row.activePlan" type="primary" size="mini" @click="checkout(scope.row)">-->
<!--                        {{$t('users_tab_subscriptions_plans_pay')}}s-->
<!--                    </el-button>-->
<!--                    <el-button v-if="scope.row.activePlan && scope.row.stripeProductId !== null && scope.row.ifCanceledSubscription" @click="cancelOpenModal(scope.row)" type="primary" size="mini">-->
<!--                        {{$t('users_tab_subscriptions_plans_cancel')}}-->
<!--                    </el-button>-->
<!--                </template>-->
            </el-table-column>
        </el-table>
        <el-button
            style="margin-top: 20px;"
            size="mini"
            type="primary"
            :loading="loaderPortal"
            @click="generatePortalSession">
          Manage Billing
        </el-button>
        <stripe-checkout
                v-show="false"
                ref="sessionRef"
                :pk="publishableKey"
                :session-id="sessionId"
        >
            <template slot="checkout-button">
                <el-button
                        @click="$refs.sessionRef.redirectToCheckout()"
                        color="#42b883"
                        large
                        dark
                >Subscribe</el-button>
            </template>
        </stripe-checkout>
        <create-subscription-modal ref="createSubscriptionModal" @close="loadSubscriptionsList"/>
    </div>
</template>

<script>
  import moment from 'moment'
  import axios from 'axios'
  import { StripeCheckout } from 'vue-stripe-checkout';
  import CreateSubscriptionModal from "./CreateSubscriptionModal";

  export default {
    name: "settingsSubscriptions",
    computed:{
      user() {
        return this.$store.state.user
      },
      listWithSum() {
        if (this.list.length) {
          const sumRow = {
            total: 0,
            action: true
          }
          const newList = this.list.map(val => ({...val, total: typeof val.usersQty === 'number' ? val.usersQty * val.price : val.total }))
          const total = newList.reduce((prev, curr) => {
            const value = Number(curr.total);
            if (!isNaN(value)) {
              return prev + curr.total;
            } else {
              return prev;
            }
          }, 0)
          console.log('TOTAL', total)
          sumRow.total = total
          return [...newList, sumRow]
        }
        return this.list
      },
      subscription() {
        return this.$store.state.subscription
      }
    },
    components: {
      CreateSubscriptionModal,
      StripeCheckout
    },
    data: () => ({
      sessionId: null,
      moment: moment,
      loader: false,
      loaderPortal: false,
      list: [],
      //
      loading: false,
      // publishableKey: 'pk_live_nEouk4mrAocLzr3WqElMDZ3V0080nQcsWs',
      // publishableKey: 'sk_test_HMYf8GsLG2ecJkMMdqqR06Z100nQh3morI',
      publishableKey: process.env.VUE_APP_STRIPE_KEY,
      items: [
        {
          plan: 'price_1HH5H0BFmo7iKjnP3whZjNfV',
          quantity: 1
        }
      ],
      successUrl: `http://localhost:8080/success-callback`,
      cancelUrl: 'http://localhost:8080/cancel-callback',

    }),
    mounted() {
      this.loadUserSubscription()
    },
    methods: {
      tester() {
        console.log(process.env)
      },
      async loadUserSubscription() {
        try {
          this.loader = true
          let loader = this.$loading.show()
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          const result = axios.get(`/api/v1/stripe/userSubscription?companyId=${this.$route.query.companyId}`)
          this.loader = false;
          loader.hide()
          console.log('result', result)
        } catch (err) {
          console.log(err)
        }
      },
      async generatePortalSession() {
        this.loaderPortal = true
        let loader = this.$loading.show()
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        const { data } = await axios.get(`/api/v1/stripe/generatePortalSession?companyId=${this.$route.query.companyId}`)
        window.open(data.portalSession.url, '_self').focus();
        this.loaderPortal = false;
        loader.hide()
      },
      loadSubscriptionsList(){
        this.loader = true;
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .get(`/api/v1/subscription/price/list`)
          .then(async response => {
            console.log('response', response)
            const currentDay = moment().format('D MMM YYYY');
            try {
              this.list = response.data.list.map((row, index) => {
                if (index === 0) {
                  row.startDate = currentDay
                  row.usersQty = 'Unlimited'
                  row.cycle = 'Month'
                  row.total = row.price
                } else if (index === 1) {
                  row.cycle = 'Month'
                  row.usersQty = this.subscription.volumesSize
                  row.min = this.subscription.volumesSize
                  row.total = 0
                } else if (index === 2) {
                  row.cycle = 'Month'
                  row.usersQty = this.subscription.onlyOfficesQty
                  row.min = this.subscription.onlyOfficesQty
                  row.total = 0
                }
                return row
              })
              // const userSubscriptions = await this.getUserSubscriptions(this.$route.query.companyId);
              // const currentDay = moment().format('YYYY-MM-DD');
              // const endOfCurrentMoth = moment().endOf('month');
              // const daysInCurrentMonth = moment().daysInMonth();
              // const diff = Math.floor(moment.duration(endOfCurrentMoth.diff(currentDay)).asDays());
              //
              // this.list = response.data.list.map(function (val){
              //   val.currentPrice = val.price / daysInCurrentMonth * diff;
              //   val.activePlan = val.id === userSubscriptions.subscriptionId;
              //   if (val.id === userSubscriptions.subscriptionId) {
              //     val.expiredDate = userSubscriptions.expiredDate ? moment(userSubscriptions.expiredDate, 'X').format('YYYY-MM-DD') : '';
              //     val.ifCanceledSubscription = !!userSubscriptions.stripeSubscriptionId
              //   }
              //   return val
              // });

              this.loader = false;
              loader.hide()
            } catch (err){
              console.log(err);
              this.loader = false;
              loader.hide()
            }
          })
          .catch(error => {
            this.loader = false;
            loader.hide()
          });
      },
      getUserSubscriptions(companyId) {
        return new Promise((resolve, reject) => {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .get(`/api/v1/subscription/getusersubscription?companyId=${companyId}`)
            .then(response => {
              resolve(response.data.subscriptionUsersPackageId);
              loader.hide()
            })
            .catch(error => {
              loader.hide()
            });
        })
      },
      pay(row){
        this.$refs.checkoutRef.successUrl = `http://localhost:8080/success-callback?companyId=${this.$route.query.companyId}&userId=${this.user.user.id}`
        this.$refs.checkoutRef.redirectToCheckout();
      },
      cancelOpenModal(){
        this.$confirm(this.$t('users_tab_subscriptions_plans_cancel_subscription'),{
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('general_ok'),
          cancelButtonText: this.$t('general_cancel'),
          type: 'info'
        }).then(() => {
          this.cancel()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('general_cancel')
          });
        });
      },
      cancel(){
        return new Promise((resolve, reject) => {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .get(`/api/v1/subscription/cancelSubscription?companyId=${this.$route.query.companyId}`)
            .then(async response => {
              try {
                this.loadSubscriptionsList()
              } catch (err){
                console.log(err)
              }
              console.log(response);

              loader.hide()
            })
            .catch(error => {
              loader.hide()
            });
        })
      },
      checkout (row) {
        return new Promise((resolve, reject) => {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .get(`/api/v1/subscription/createSubscriptionSession?subscriptionId=${row.id}&companyId=${this.$route.query.companyId}`)
            .then(response => {
              console.log(response);
              if(response.data.sessionId){
                this.sessionId = response.data.sessionId.id;
                this.$refs.sessionRef.redirectToCheckout();
              } else {
                setTimeout(() => {
                  this.loadSubscriptionsList()
                }, 1000)
              }
              loader.hide()
            })
            .catch(error => {
              loader.hide()
            });
        })
        // this.$refs.checkoutRef.redirectToCheckout();
      },
      submit () {
        this.$refs.elementsRef.submit();
      },
      tokenCreated (token) {
        this.token = token;
        // for additional charge objects go to https://stripe.com/docs/api/charges/object
        this.charge = {
          source: token.id,
          amount: this.amount, // the amount you want to charge the customer in cents. $100 is 1000 (it is strongly recommended you use a product id and quantity and get calculate this on the backend to avoid people manipulating the cost)
          description: this.description // optional description that will show up on stripe when looking at payments
        };
        this.sendTokenToServer(this.charge);
      },
      sendTokenToServer (charge) {

        // Send to charge to your backend server to be processed
        // Documentation here: https://stripe.com/docs/api/charges/create

      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
      formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return '0 Bytes';

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
      },
      createSubscriptionOpenModal(){
        this.$refs.createSubscriptionModal.openModal()
      },
      payConfirm() {
        this.$confirm('Increase in data storage capacity connot be downgraded', 'Please note', {
          confirmButtonText: 'Confirm',
          cancelButtonText: this.$t('general_cancel'),
          type: 'info'
        }).then(() => {
          this.test()
        })
      },
      test() {
        const payload = {
          do_size: this.listWithSum[1].usersQty,
          onlyOffice_qty: this.listWithSum[2].usersQty
        }
        this.loading = true
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/stripe/createSessionPay?companyId=${this.$route.query.companyId}`, payload)
            .then(async response => {
              try {
                if(response.data.session){
                  this.loading = false
                  this.sessionId = response.data.session.id;
                  console.log('response.data.session.id', response.data.session.id)
                  if (this.sessionId) this.$refs.sessionRef.redirectToCheckout();
                  await this.$store.dispatch('getCompanyLayout')
                  await this.loadSubscriptionsList()
                  this.loading = false
                  this.notification(this.$t('general_success'), 'The operation was successful, the money will be debited in the next payment period, for more detailed information, go to the stripe account by clicking on the “Manage Billing” button', "success")
                } else {
                  setTimeout(() => {
                    this.$store.dispatch('getCompanyLayout')
                    this.loadSubscriptionsList()
                    this.loading = false
                  }, 1000)
                }
              } catch (err) {
                console.log(err)
                this.$store.dispatch('getCompanyLayout')
                this.loadSubscriptionsList()
                this.loading = false
              }
            })
      },
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '';
            return;
          }
          console.log('data ===', data)
          const values = data.map(item => Number(item[column.property]));
          console.log('values ===', values, column)
          if (!values.every(value => isNaN(value))) {
            sums[index] = '$ ' + values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          } else {
            sums[index] = '';
          }
        });

        return sums;
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
    }
  }
</script>

<style lang="scss" scoped>
.input-number {
  width: 110px;
  line-height: 26px;
  position: relative;
  display: inline-block;
  /deep/.el-input-number__decrease {
    width: 28px;
    font-size: 12px;
    left: 1px;
    border-radius: 4px 0 0 4px;
    border-right: 1px solid #dcdfe6;
    position: absolute;
    z-index: 1;
    top: 1px;
    height: auto;
    text-align: center;
    background: #f5f7fa;
    color: #606266;
    cursor: pointer;
    line-height: 26px;
  }
  /deep/.el-input-number__increase {
    width: 28px;
    font-size: 12px;
    right: 1px;
    border-radius: 0 4px 4px 0;
    border-left: 1px solid #dcdfe6;
    position: absolute;
    z-index: 1;
    top: 1px;
    height: auto;
    text-align: center;
    background: #f5f7fa;
    color: #606266;
    cursor: pointer;
  }
  /deep/.el-input {
    display: block;
    font-size: 12px;
    background: #fff;
    .el-input__inner {
      height: 28px;
      line-height: 28px;
      padding-left: 35px;
      padding-right: 35px;
      -webkit-appearance: none;
      text-align: center;
      background-color: #fff;
      background-image: none;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      box-sizing: border-box;
      color: #606266;
      display: inline-block;
      font-size: inherit;
      outline: none;
      transition: border-color .2s cubic-bezier(.645,.045,.355,1);
      width: 100%;
    }
  }
}
</style>
